<div class="detail-tabs">
  <div class="container-lg p-0">
    <div class="nav nav-tabs u-tabs">

      <div class="nav-item u-tabs__item" *ngIf="(cruise$ | async)?.steps?.length">
        <a (click)="selectTab('map')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'map'">Itinerario</a>
      </div>

      <div class="nav-item u-tabs__item" *ngIf="(cruise$ | async)?.selectedSolution?.excursions">
        <a (click)="selectTab('excursions')" class="nav-link u-tabs__link" [class.active]="selectedSectionId === 'excursions'">Escursioni</a>
      </div>

      <div class="nav-item u-tabs__item d-none d-md-block" *ngIf="shipService$ | async">
        <a (click)="selectTab('ship')" class="nav-link u-tabs__link " [class.active]="selectedSectionId === 'ship'">Ponti e Cabine</a>
      </div>

    </div>
  </div>
</div>
